var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "todaycourse-page" },
    [
      _c(
        "van-tabs",
        {
          on: { click: _vm.onClick },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        _vm._l(_vm.titleArray, function (item, index) {
          return _c(
            "van-tab",
            {
              key: "tabpage" + index,
              attrs: { title: item, "title-class": "todaycourse-tabtitle" },
            },
            [
              _c("teas-today-course-main", {
                ref: "todaycoursemain" + index,
                refInFor: true,
                attrs: {
                  classType: _vm.typeArray[index],
                  "is-design": _vm.isDesign,
                  url: _vm.url,
                },
                on: { itemClick: _vm.itemClick },
              }),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }